import { Injectable } from '@angular/core';
import { STORE_DATA_FOR_MINUTES } from '../lib/contsants';

@Injectable({
  providedIn: 'root',
})
export class StorageService {
  storeJSON(key, value) {
    localStorage.setItem(key, JSON.stringify(value));
  }

  storeScalar(key, value) {
    localStorage.setItem(key, value);
  }

  getJSON(key: string): any {
    try {
      return JSON.parse(this.getScalar(key));
    } catch (e) {
      return null;
    }
  }

  getScalar(key: string): any {
    return localStorage.getItem(key);
  }

  getBoolean(key: string, fallback = false): boolean {
    const val = localStorage.getItem(key);
    if (val === null) {
      return fallback;
    }

    return val === 'true';
  }

  removeJSON(key) {
    localStorage.removeItem(key);
  }

  returnJSONIfValid(key) {
    try {
      const data = JSON.parse(this.getScalar(key));
      return /*data.expires > new Date() ?*/ data.data; // : null;
    } catch (e) {
      return null;
    }
  }

  storeJSONWithExpiry(key, value) {
    localStorage.setItem(key, JSON.stringify({ data: value, expires: this.setExpiryDate() }));
  }

  setExpiryDate() {
    const date = new Date();
    const newDate = date.setMinutes(date.getMinutes() + STORE_DATA_FOR_MINUTES);
    return newDate;
  }
}
